module.exports = __webpack_public_path__ + "static/img/collection.50bcec96.png";